/* eslint-disable */
/* globals queryString */
import React from 'react'
import ReactDOM from 'react-dom'
import Visual from 'bam-node-evp/src/Visual'
import SavantModel from 'bam-node-evp/src/Models/SavantModel.ts'
import LoadSchema from './Schema'

const player = {
    playerName: opts.playername,
    playerId: opts.playerid,
    playerType: opts.playertype,
}

const { schema } = opts
schema.showToolTip = true

let data

if (schema.skipSavantModel) {
    data = opts.data.data
} else {
    data = SavantModel(schema, opts.data.data)
}

if (queryString.scale === 'true') {
    let shapeRatio = window.innerWidth / 500
    schema.shapeRatio = shapeRatio

    if (queryString.width) {
        shapeRatio = queryString.width / 500
        schema.shapeRatio = shapeRatio
    }
}

window.onresize = function () {
    const shapeRatio = window.innerWidth / 500
    schema.shapeRatio = shapeRatio
    ReactDOM.unmountComponentAtNode(document.getElementById('evp'))
    loadFrame()
}

loadFrame()

function loadFrame() {
    ReactDOM.render(
        <Visual player={player} data={data} chart={schema} />,
        document.getElementById('evp')
    )
}
